import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";
import { ArrowRight } from "lucide-react";

const SEARCHES = [
  {
    title: "Executive Chef",
    place: "Luxury Resort · Middle East",
    note: "Pre-opening leadership role",
  },
  {
    title: "General Manager",
    place: "Boutique Restaurant Group · Europe",
    note: "Multi-venue F&B leadership",
  },
  {
    title: "Director of Food & Beverage",
    place: "Five-Star Hotel · Asia",
    note: "Established luxury property",
  },
];

const CurrentlySeeking = () => (
  <section data-testid="currently-seeking-section" className="bg-ivory py-20 lg:py-28 hairline">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <Reveal>
        <div className="flex flex-wrap items-baseline justify-between gap-4 mb-12">
          <div className="flex items-center gap-4">
            <span className="font-serif italic text-lg text-bronze">—</span>
            <p className="eyebrow">Currently Seeking</p>
          </div>
          <p className="text-[10px] tracking-[0.2em] uppercase text-ink/40">
            A selection of representative searches
          </p>
        </div>
      </Reveal>

      <div className="border-t border-ink/10">
        {SEARCHES.map((s, i) => (
          <Reveal key={s.title} delay={0.08 * i}>
            <div
              data-testid={`seeking-role-${i}`}
              className="group grid lg:grid-cols-12 items-baseline gap-2 lg:gap-6 py-8 border-b border-ink/10 hover:pl-4 transition-all duration-700"
            >
              <h3 className="lg:col-span-5 font-serif text-2xl lg:text-4xl font-light text-ink group-hover:text-bronze transition-colors duration-500">
                {s.title}
              </h3>
              <p className="lg:col-span-4 text-[11px] tracking-[0.2em] uppercase text-ink/50">
                {s.place}
              </p>
              <p className="lg:col-span-3 text-xs text-ink/40 lg:text-right italic font-serif">
                {s.note}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <button
          data-testid="seeking-cta-submit-cv"
          onClick={() => scrollToId("#candidates")}
          className="group mt-10 inline-flex items-center gap-3 text-[11px] tracking-[0.25em] uppercase text-ink hover:text-bronze transition-colors duration-500"
        >
          Submit Your CV
          <ArrowRight size={14} strokeWidth={1.5} className="group-hover:translate-x-1.5 transition-transform duration-500" />
        </button>
      </Reveal>
    </div>
  </section>
);

export default CurrentlySeeking;
